import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchConfig } from "../lib/api";

// Injects the Meta Pixel ONLY after consent is accepted and only if a pixel id is configured.
export default function MetaPixel() {
  const { data: config } = useQuery({ queryKey: ["config"], queryFn: fetchConfig });
  const pixelId = config?.meta_pixel_id;

  useEffect(() => {
    if (!pixelId) return;
    let injected = false;
    const inject = () => {
      if (injected || window.fbq || localStorage.getItem("viralya-consent") !== "accepte") return;
      injected = true;
      /* eslint-disable */
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */
      window.fbq("init", pixelId);
      window.fbq("track", "PageView");
    };
    inject();
    const onConsent = () => inject();
    window.addEventListener("viralya-consent", onConsent);
    return () => window.removeEventListener("viralya-consent", onConsent);
  }, [pixelId]);

  return null;
}
